<template>
  <fragment>
    <fragment v-for="(op, opIndex) in optionsData" :key="opIndex">
      <li :class="[]"
          class="p-[1px] cursor-pointer">
        <i v-if="op?.children?.length"
           :class="['mr-3 w-1',chevronClasses(op.expand)]"
           @click="op.expand = !op.expand"/>
        <input ref="checkBoxRef" :checked="checkItemIsSelected(op.id)" :type="multiple ? 'checkbox' : 'radio'"
               @change="handleClickOptionItem(op)"/>
        <span class="ml-2" @click="handleClickOptionItem(op)">{{ op.text }}</span>
      </li>
      <ul v-if="op?.children?.length && op?.expand" class="ml-5">
        <OptionItems
            :checkItemIsSelected="checkItemIsSelected"
            :handleClickOptionItem="handleClickOptionItem "
            :multiple="multiple"
            :optionsData="op.children"
        />
      </ul>
    </fragment>
  </fragment>
</template>

<script>
export default {
  name: "OptionItems",
  props: {
    optionsData: {
      type: Array,
      required: true,
    },
    handleClickOptionItem: {
      type: Function,
      required: true,
    },
    checkItemIsSelected: {
      type: Function,
      required: true,
    },
    multiple: {
      type: Boolean,
      default: false
    },

  },
  methods: {
    chevronClasses(isOpen) {
      return isOpen ? "fa-sharp fa-solid fa-caret-down" : "fa-sharp fa-solid fa-caret-right"
    },
  }
}
</script>

<style scoped>

</style>
